import Vue from 'vue';
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';
import notificationService, { setNotifyHandler } from '@/js/services/notification-service';

Vue.use(Notifications, {name: 'notifyOrig', velocity});

setNotifyHandler(Vue.notifyOrig);

Vue.prototype.$notify = notificationService;


// notificationService.info('Info!!!!');
// notificationService.error('Error!!!!');
